import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationEn from "./locales/en/translation.json";
import translationEs from "./locales/es/translation.json";

/**
 * i18next setup.
 *
 * Two fixes: the `i18next-xhr-backend` plugin has been dropped — both locales
 * are bundled as JSON, so there was nothing to fetch and the deprecated backend
 * only added a failed request — and `initReactI18next` is now registered, which
 * is what actually connects i18next to the React tree.
 *
 * This module also has to be imported for any of it to run. It wasn't.
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translations: translationEn },
      es: { translations: translationEs },
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;
